import { render, staticRenderFns } from "./LsFAQ.vue?vue&type=template&id=491502bb&scoped=true&"
import script from "./LsFAQ.vue?vue&type=script&lang=js&"
export * from "./LsFAQ.vue?vue&type=script&lang=js&"
import style0 from "./LsFAQ.vue?vue&type=style&index=0&id=491502bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491502bb",
  null
  
)

export default component.exports